/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { useSelector, connect } from 'react-redux';
import { trackEvent as track } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { bool, func, object, string } from 'prop-types';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';

import BrandLogo from '../assets/BrandLogo';
import { useUIDSeed } from 'react-uid';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import Disclaimer from '../Common/Disclaimer';
import SocialMedia from '../SocialMedia';
import Icons from '../assets/Icons';
import { RecommendedProduct } from '../Common/RecommendedProduct';
// import { ProductCard } from '../Common/ProductCard';
import { getAccessTokenSafely } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { getProfileInfo } from '../../../../state/Selectors';
import { useMutation } from 'react-query';
import composePersonalizedContent from '../../../../../../../apis/chatgpt-apis/composePersonalizedContent';

const useStyles = (mobile) =>
    makeStyles((theme) => ({
        contentContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
            zIndex: '2',
            height: '100%',
            width: '100%',
            maxWidth: '715px',
            padding: '24px 0 12px 0',
            overflow: 'hidden',
            '& > h2': {
                color: `${theme.palette.common.black}!important`,
                textAlign: 'center',
                fontWeight: '700 !important',
                fontSize: '16px !important',
                lineHeight: '24px',
                textTransform: 'none !important',
                margin: `${mobile ? '0 0 16px 0' : '0 0 32px 0'} !important`,
            },
        },
        poemResultContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            padding: '24px 30px',
            margin: '12px 0 24px 0',
            width: '100%',
            height: '100%',
            backgroundColor: `${theme.palette.common.white}`,
            color: `${theme.palette.common.black} !important`,
            textAlign: 'center',
            lineHeight: '28px',
            '& > span': {
                fontFamily: 'Dosis, sans-serif',
                color: `${theme.palette.common.black}!important`,
            },
            '& > span:first-child': {
                fontFamily: `${'Dosis, sans-serif'}`,
                color: `${theme.palette.common.black}!important`,
            },
            '& > p': {
                margin: 0,
                fontSize: `${mobile ? '16px' : '18px'} !important`,
                fontFamily: 'Lato, sans-serif',
                fontWeight: `500`,
                lineHeight: '28px',
                color: `${theme.palette.common.black}!important`,
                overflowWrap: 'break-word',
            },
        },
        optionContainer: {
            display: 'flex',
            gap: '24px',
            '& > *': {
                position: 'relative',
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                textDecoration: 'none',
                fontStyle: 'normal',
                color: '#117B91',
                fontSize: `${mobile ? '14px' : '16px'} !important`,
                lineHeight: mobile ? '20px' : '26px',
                fontWeight: 700,
                cursor: 'pointer',
                marginBottom: '10px',
                borderBottom: `2px solid #117B91`,
            },
            '& > i': {
                '& svg': {
                    maxWidth: '16px',
                },
            },
        },
        poemImageWrapper: {
            position: 'absolute',
            left: '-9999px',
            width: '378px !important',
            height: '611px !important',
        },
        poemImageContainer: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            zIndex: 1000,
            borderRadius: 0,
            margin: 0,
            background: 'linear-gradient(0deg, #dffaff 0%, #117B91 90%)',
            padding: '20px 30px 35px 30px',
            '& > *': {
                zIndex: 1200,
            },
            '& > p': {
                fontSize: `16px !important`,
                // color: `white !important`,
            },
            '& > p:last-of-type': {
                marginBottom: '30px',
            },
        },
        poemImageHeader: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '100%',
        },
        poemImageText: {
            display: 'flex',
            gap: '10px',
            margin: '0',
            fontWeight: 600,
            fontStyle: 'normal',
            lineHeight: '28px',
            color: 'white',
            fontFamily: `Lato, sans-serif !important`,
        },
        poemImageFooter: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '& > span': {
                display: 'flex',
                margin: 0,
            },
        },
        poemFor: {
            fontSize: `${mobile ? '18px' : '20px'} !important`,
            fontWeight: 700,
            color: `white !important`,
            lineHeight: mobile ? '26px' : '32px',
            textTransform: 'capitalize',
            marginBottom: mobile ? '34px' : '24px',
            fontFamily: `Lato, sans-serif !important`,
        },
        poemForImage: {
            margin: '15px 0 24px 0',
            fontFamily: 'Lato, sans-serif',
        },
        spacer: {
            margin: '12px 0',
        },
        buttonWrapper: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '10px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        buttonContainer: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
        },
        button: {
            width: '155px !important',
            height: '36px',
            borderRadius: '3px !important',
            margin: '0 0 12px 0 !important',
            fontSize: '14px !important',
            lineHeight: '20px',
            textTransform: 'none !important',
            backgroundColor: `#117B91 !important`,
            border: `1px solid #117B91 !important`,
            letterSpacing: '0.04em',
            color: `${theme.palette.common.white}!important`,
            fontWeight: '700 !important',
            padding: '6px 12px !important',
            whiteSpace: 'nowrap',
            '&:disabled': {
                color: '#C4C4C4 !important',
                border: `1px solid #C4C4C4 !important`,
                backgroundColor: `${theme.palette.common.white} !important`,
            },
        },
        secondaryButton: {
            border: '1px solid #117B91 !important',
            color: '#117B91 !important',
            backgroundColor: `${theme.palette.common.white} !important`,
        },
        error: {
            textAlign: 'center !important',
            fontWeight: '400',
            fontSize: '14px !important',
            lineHeight: '20px',
            color: '#DF3030',
            margin: '0 !important',
            marginBottom: '12px !important',
        },
        floraVerseTitleContainer: {
            width: '100%',
            margin: '24px 0',
            padding: '15px 20px',
            boxShadow: 'none',
            borderRadius: '8px',
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& button': {
            all: 'unset !important',
            background: 'none !important',
            border: 'none !important',
            cursor: 'pointer !important'
            },
            '& h1': {
                textTransform: 'unset !important',
                fontSize: `${mobile ? '40px' : '72px'} !important`,
                lineHeight: ` ${mobile ? '60px' : '94px'}!important`,
                fontWeight: '800 !important',
                fontFamily: 'Dosis !important',
                marginBottom: `'16px' !important`,
            },
        },
    }));

const ResultPage = ({
    mobile,
    poem,
    recipient,
    previousMomVerseEnabled,
    handleResetPoem,
    handleSetPreviousPoemMomVerse,
    trackEvent,
    occasion,
    handlePoemMutationSuccess,
    handlePoemMutationError,
    selections,
    error,
    setError,
    setRecipient,
}) => {
    const classesLayout = useStyles(mobile);
    const classes = classesLayout();
    const [isPoemCopied, setIsPoemCopied] = useState(false);
    const [retries, setRetries] = useState(3);

    const createPoemMutation = useMutation({
        mutationFn: composePersonalizedContent,
        onSuccess: ({ data: { poem, isSuccessful } }) =>
            handlePoemMutationSuccess(poem, isSuccessful, () => {
                setRecipient(selections?.forMy ?? '');
                setRetries(retries - 1);
            }),
        onError: handlePoemMutationError,
    });

    const brand = useSelector(getBrand);
    const featureFlags = useSelector(getFeatureFlags);
    const profileInfo = useSelector(getProfileInfo);

    const poemImageRef = useRef(null);
    const timeoutRef = useRef(null);

    const seed = useUIDSeed();

    const whichPoemPageProductVariantToDisplay = featureFlags?.['which-poem-page-product-variation-to-display'];
    const isNewButtonFlowEnabled = featureFlags?.['is-poem-page-new-button-flow-enabled'];
    const { button: buttonUIABTest} = whichPoemPageProductVariantToDisplay;
    const isPoemDownloadEnabled = featureFlags?.['is-poem-page-download-enabled'];

    const handleCtaTracking = (action = '', label = '') => {
        trackEvent({
            eventCategory: occasion,
            eventAction: action,
            eventLabel: label,
        });
    };

    const handleCopyClick = () => {
        if (
            typeof navigator !== 'undefined' &&
            typeof navigator.clipboard !== 'undefined' &&
            typeof navigator.permissions !== 'undefined'
        ) {
            navigator.clipboard.writeText(poem);
            setIsPoemCopied(true);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                setIsPoemCopied(false);
            }, 3000);
        }
    };

    const getDataUrl = async () => {
        if (typeof window === 'undefined' || !window || !poemImageRef.current) return;
        window.scrollTo(0, 0);
        const canvas = await html2canvas(poemImageRef.current, {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY,
            scale: 2,
        });
        const dataUrl = canvas.toDataURL('image/png');
        return dataUrl || '';
    };

    const handleDownloadImage = async () => {
        const dataUrl = await getDataUrl();
        const link = document.createElement('a');
        link.download = 'poem-image.png';
        link.href = dataUrl;
        link.click();
        link.remove();
    };

    const handleComposeAgain = async () => {
        if (retries <= 0) return;
        const { forMy, whoLikes, writeA, verseOccasion } = selections;
        const token = await getAccessTokenSafely();
        const captcha = '';
        const interests = Object.values(whoLikes).filter((interest) => !!interest);
        const occasion = verseOccasion;
        setError('');
        createPoemMutation.mutate({
            token,
            brand: brand?.description || '1-800-Flowers',
            interests,
            enforceCharacterLimit: false,
            recipient: forMy,
            userId: profileInfo?.email || '',
            verseType: writeA,
            captchaToken: captcha,
            occasion,
        });
    };
    const recipientText = recipient === 'Wife' ? `My ${recipient}` : recipient;
    const occasionQuery = [
        "birthday", "sympathy", "christmas", "thank_you", "thinking_of_you",
        "get_well", "anniversary", "fall", "congratulations", "housewarming",
        "mothers_day", "fathers_day", "friendship", "valentines_day", "romance",
        "harvest", "celebration", "thanksgiving", "everyday", "easter",
        "holiday", "love_romance", "memorial", "winter", "just_because",
        "halloween", "spring", "game_day", "passover_seder", "business",
        "encouragement", "summer", "retirement", "graduation", "bosses_day",
        "employee_recognition", "welcome_baby", "grandparents_day",
        "back_to_school", "im_sorry", "wedding", "administrative_professional_day",
        "hanukkah", "patriotic", "new_year", "miss_you",
        "international_womens_day", "rosh_hashanah", "earth_day", "st_patricks_day",
        "welcome", "kwanzaa", "first_day_of_fall", "missing_you", "corporate_gifting",
        "pet_sympathy", "new_baby", "back_to_work", "administrative_professionals_day",
        "administrative_professionals_week", "teacher_appreciation_week",
        "friendsgiving", "movie_night", "baby_shower", "nurses_week",
        "first_day_of_summer", "bridal_shower", "national_siblings_day",
        "work_anniversary", "labor_day", "mother_in_law_day", "first_day_of_spring",
        "wedding_anniversary", "prom", "ramadan", "wife_appreciation_day",
        "breast_cancer_awareness_month", "in_memory_of", "new_years_eve", "religious",
        "bachelorette_party", "super_bowl_sunday", "husband_appreciation_day",
        "engagement", "memorial_day", "pride", "galentines_day", "cinco_de_mayo",
        "gender_reveal", "purim", "passover_sedar", "bachelor_party", "veterans_day",
        "presidents_day", "pride_month", "kwanza", "baptism", "election_day",
        "black_history_month", "columbus_day", "mardi_gras", "communion",
        "covid_remembrance_day", "dia_de_los_muertos", "diwali", "eid_al_fitr",
        "black_friday", "groundhog_day"
    ];
    
    const getCampaignOccasionQuery = () => {
        const sanitizedOccasion = selections?.verseOccasion?.toLowerCase().replace(/\s+/g, "_");
        return occasionQuery.find(oc => oc.includes(sanitizedOccasion)) || '';
    }
    
    const renderProductsFloraVerse = ({ mobile }) => {
        return (
            <>
                <RecommendedProduct
                    mobile={mobile}
                    title={`Handmade Bouquets for ${recipientText}`}
                    campaignFeature="Momverse Floral"
                    occasion={getCampaignOccasionQuery()}
                    isFloraVerse
                />
                <RecommendedProduct
                    mobile={mobile}
                    title={`Unique Gifts for ${recipientText}`}
                    campaignFeature="Momverse Non-Floral"
                    occasion={getCampaignOccasionQuery()}
                    isFloraVerse
                />
                {/* <ProductCard
                    mobile={mobile}
                    handleProductClick={() => handleCtaTracking('CardIsle Click', 'Redirect ~ /send-greeting-cards')}
                    title={`A Personalized Card For ${recipientText}`}
                    pricePriceText="From $5.99"
                    imageSrc="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt4bafb998596b3722/661d47f816c12059a75dc543/0cd653e364c84c3ca945bdcca8d94d8a.jpg"
                    pdpLink="/send-greeting-cards?cardisle_tags=mother%27s%20day"
                    isFloraVerse
                /> */}
            </>
        );
    };

    const renderProducts = () =>renderProductsFloraVerse({ mobile });

    const renderPoem = () =>
        poem.split('\n').map((str, ind) => {
            if (!str) return <br key={`poem-part-break-${seed(ind)}`}></br>;
            return <p key={`poem-part-${seed(str)}`}>{str}</p>;
        });

    useEffect(() => {
        setError('');
        if (typeof window !== 'undefined') window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (buttonUIABTest) {
            trackEvent({
                eventCategory: 'Test Impression',
                eventAction: 'FloraVerse Button Footer',
                eventLabel: `Variant - ${isMobile ? 'Mobile' : 'Desktop'}`,
                nonInteraction: '1',
            });
        } 
    }, []);

    return (
            <div className={classes.contentContainer}>
            <div className={classes.floraVerseTitleContainer}>
                <button
                    type="button"
                    onClick={() => {
                        handleCtaTracking('CTA Click', 'Start Over');
                        handleResetPoem();
                    }}
                >
                    <h1>Flora Verse</h1>
                </button>
            </div>
                <div className={classes.poemResultContainer}>
                    <span className={classes.poemFor}>{`${selections?.writeA} For ${recipientText || 'You'}`}</span>
                    {renderPoem()}
                    <div className={classes.spacer}></div>
                    {isMobile && <SocialMedia getDataUrl={getDataUrl} mobile={mobile}/>}
                    <div className={classes.optionContainer}>
                        {
                            <>
                                <Tooltip open={isPoemCopied} placement="bottom" title="Poem copied!">
                                    <i
                                        onClick={() => {
                                            handleCtaTracking('CTA Click', 'Copy Text');
                                            handleCopyClick();
                                        }}
                                    >
                                        Copy Text <Icons icon="copyText" />
                                    </i>
                                </Tooltip>
                                {!isMobile && isPoemDownloadEnabled && (
                                    <i
                                        onClick={() => {
                                            handleCtaTracking('CTA Click', 'Save as Image');
                                            handleDownloadImage();
                                        }}
                                    >
                                        Save as Image <Icons icon="gallery" />
                                    </i>
                                )}
                            </>
                        }
                    </div>
                </div>
                <div className={classes.poemImageWrapper}>
                    <div
                        ref={poemImageRef}
                        aria-hidden="true"
                        className={`${classes.poemResultContainer} ${classes.poemImageContainer}`}
                    >
                        <h4
                            className={`${classes.poemForImage} ${classes.poemFor}`}
                        >{`A ${selections?.writeA || 'Poem'} For ${recipientText || 'You'} `}</h4>
                        {renderPoem()}
                        <div className={classes.poemImageFooter}>
                            <span className={classes.poemImageText}>
                                <div className={classes.poemImageHeader}>
                                    <BrandLogo brandId={brand?.code} />
                                </div>
                            </span>
                            <span className={classes.poemImageText}>{`www.${brand?.domain}.com/account/floraverse`}</span>
                        </div>
                    </div>
                </div>
                <div className={classes.buttonWrapper}>
                    <div className={classes.buttonContainer}>
                        {isNewButtonFlowEnabled && retries > 0 && (
                            <Button
                                onClick={() => {
                                    handleCtaTracking('CTA Click', 'Compose Again ~ New');
                                    handleComposeAgain();
                                }}
                                type="button"
                                tabIndex="0"
                                className={classes.button}
                                disabled={retries <= 0 || createPoemMutation.isLoading}
                            >
                                {createPoemMutation.isLoading ? (
                                    <CircularProgress style={{ width: '20px', height: '20px' }} />
                                ) : (
                                    'Compose Again'
                                )}
                            </Button>
                        )}
                        {(isNewButtonFlowEnabled && retries <= 0) || !isNewButtonFlowEnabled ? (
                            <Button
                                onClick={() => {
                                    handleCtaTracking('CTA Click', 'Start Over');
                                    handleResetPoem();
                                }}
                                type="button"
                                tabIndex="0"
                                className={classes.button}
                                disabled={createPoemMutation.isLoading}
                            >
                                Start Over
                            </Button>
                        ) : null}
                        <Button
                            onClick={() => {
                                handleCtaTracking('CTA Click', 'Previous Version');
                                handleSetPreviousPoemMomVerse();
                            }}
                            type="button"
                            tabIndex="0"
                            className={`${classes.button} ${classes.secondaryButton}`}
                            disabled={!previousMomVerseEnabled || createPoemMutation.isLoading}
                        >
                            Previous Version
                        </Button>
                    </div>
                    {error && isNewButtonFlowEnabled && <p className={classes.error}>{error}</p>}
                </div>
                {renderProducts()}
                <Disclaimer />
            </div>
    );
};

ResultPage.defaultProps = {
    mobile: false,
    poem: '',
    recipient: '',
};

ResultPage.propTypes = {
    mobile: bool,
    poem: string,
    recipient: string,
    previousMomVerseEnabled: bool,
    handleResetPoem: func.isRequired,
    handleSetPreviousPoemMomVerse: func.isRequired,
    occasion: string.isRequired,
    error: string.isRequired,
    handlePoemMutationSuccess: func.isRequired,
    handlePoemMutationError: func.isRequired,
    selections: object.isRequired,
    setError: func.isRequired,
    setRecipient: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(connect(null, mapDispatchToProps));

export default enhance(ResultPage);
